import React, { ReactElement } from 'react';
import NavLink from '../../design-system/NavLink';

const ContactArea: React.FC = (): ReactElement => (
  <div className="flex w-full h-fit flex-row lg:justify-end text-primary text-base">
    <NavLink
      to="prezentare"
      onClick={() => {
        window.scroll(0, 0);
      }}
    >
      Prezentare
    </NavLink>
    <NavLink
      to="cabinet"
      className="justify-end md:ml-10 sm:ml-5"
      onClick={() => {
        window.scroll(0, 0);
      }}
    >
      Cabinet
    </NavLink>
    <NavLink
      to="servicii"
      className="justify-end md:ml-10 sm:ml-5"
      onClick={() => {
        window.scroll(0, 0);
      }}
    >
      Servicii
    </NavLink>
    <NavLink
      to="blog"
      className="justify-end md:ml-10 sm:ml-5"
      onClick={() => {
        window.scroll(0, 0);
      }}
    >
      Blog
    </NavLink>
    <NavLink
      to="contact"
      className="justify-end md:ml-10 sm:ml-5"
      onClick={() => {
        window.scroll(0, 0);
      }}
    >
      Contact
    </NavLink>
  </div>
);

export default ContactArea;
